import { ActionReducer, Action } from "@ngrx/store"
import { UserStore } from "@store/user"
import { Contact } from "@models/contact";

export const userReducer: ActionReducer<UserStore> = (state: UserStore = new UserStore(), action: Action) => {

  switch(action.type) {

    case POPULATE_CURRENT_USER_CONTACT:
      return new UserStore(
        action.payload)

    default:
      return state
  }
}

export const LOGIN = "LOGIN"
export const LOGIN_FAILURE = "LOGIN_FAILURE"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const FETCH_CURRENT_USER_CONTACT = "FETCH_CURRENT_USER_CONTACT"
export const FETCH_CURRENT_USER_CONTACT_FAILURE = "FETCH_CURRENT_USER_CONTACT_FAILURE"
export const POPULATE_CURRENT_USER_CONTACT = "POPULATE_CURRENT_USER_CONTACT"
export const UPDATE_USER = "UPDATE_USER"
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE"
export const REPLACE_USER = "REPLACE_USER"



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/reducers/user.ts